export default __webpack_public_path__ + "static/media/spinner.78e842f4.gif";